import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',

      gap: theme.spacing(1),
      padding: theme.spacing(0.8, 1),
      backgroundColor: theme.palette.background.default,
      borderRadius: 5,

      '& > p': {
        fontSize: '1.2rem',
      },

      '& > div': {
        flex: '1',
        alignItems: 'center',
        height: '2rem',
      },
    },
  }),
)
